exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.banner--3N5P8HC7{height:2rem;background-color:#fff;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding:.75rem}.bannerText--1wRais8s{color:#555;margin-right:.75rem;font-size:1.2rem}@media (max-width:599px){.bannerText--1wRais8s{font-size:1rem}}.bannerLink--3luUJkSb{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;background-color:#99c63b;color:#fff;text-decoration:none;border-radius:20rem;text-align:center;width:125px;height:35px;box-shadow:0 5px 3px -2px rgba(85,85,85,.2);font-size:1rem}", ""]);

// exports
exports.locals = {
	"banner": "banner--3N5P8HC7",
	"bannerText": "bannerText--1wRais8s",
	"bannerLink": "bannerLink--3luUJkSb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/banner/styles.scss
// module id = 1018
// module chunks = 0